<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-4"><a href="#/OEBPS/Away_With_the_Fairies2#Contents-A">Dedication</a></p>
<p class="body-center1"><em class="italic">This book is dedicated to my dearest twin, Jenny Pausacker.<br class="calibre2"/>With thanks as always to A.W.G., J.S.L.G., A.D.P.,<br class="calibre2"/>D.L.J.G., J.P., and S.T. They know who they are…<br class="calibre2"/>And to Jenny Darling, proprietor of Wee Nooke.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Away_With_the_Fairies-3.vue?7599728d